module.exports = __webpack_public_path__ + "img/3.b4481439.jpg";